module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$store.state.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.getRecordBranchWise
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Loan Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loanType),
      expression: "form.loanType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('loanType'),
    },
    attrs: {
      "name": "loanType",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "loanType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getRecordBranchWise]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "group"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "individual"
    }
  }, [_vm._v("Individual")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "loanType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.recoveryType),
      expression: "form.recoveryType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'recoveryType'
      ),
    },
    attrs: {
      "name": "recoveryType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "recoveryType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Daily"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Weekly"
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BiWeekly"
    }
  }, [_vm._v("BiWeekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HalfMonth"
    }
  }, [_vm._v("Half Month")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Monthly"
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Yearly"
    }
  }, [_vm._v("Yearly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OneTime"
    }
  }, [_vm._v("One Time")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "recoveryType"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planType),
      expression: "form.planType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "planType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "planType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normalReduced"
    }
  }, [_vm._v("Normal Reduced Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("Special Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual Plan")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planType"
    }
  })], 1)]), _vm._v(" "), (_vm.form.loanType === 'group' && _vm.form.branch_id !== '') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.getRecordCenterWise
    },
    model: {
      value: (_vm.collectionCenter),
      callback: function($$v) {
        _vm.collectionCenter = $$v
      },
      expression: "collectionCenter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('type'),
    },
    attrs: {
      "name": "type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "processingFee"
    }
  }, [_vm._v("Processing Fee")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fileCharge"
    }
  }, [_vm._v("File Charge")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "emi"
    }
  }, [_vm._v("EMI")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "approved"
    }
  }, [_vm._v("Approved")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Staff (Type Here)")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "staff_id",
      "filterable": false,
      "label": "name",
      "options": _vm.staffs,
      "placeholder": "Select Staff"
    },
    on: {
      "search": _vm.getStaffRecord,
      "input": _vm.getRecordAgentWise
    },
    model: {
      value: (_vm.staff),
      callback: function($$v) {
        _vm.staff = $$v
      },
      expression: "staff"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staff_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Member (Type Here)")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "filterable": false,
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "search": _vm.getMemberRecord,
      "input": _vm.getRecordMemberWise
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "staff_id"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Payment Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI Date"
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "change": _vm.selectPaymentDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Payment Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentStartDate),
      expression: "form.paymentStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentStartDate",
      "placeholder": "EMI Start Date"
    },
    domProps: {
      "value": (_vm.form.paymentStartDate)
    },
    on: {
      "change": _vm.selectBetweenPaymentDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Payment End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentEndDate),
      expression: "form.paymentEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentEndDate",
      "placeholder": "EMI End Date"
    },
    domProps: {
      "value": (_vm.form.paymentEndDate)
    },
    on: {
      "change": _vm.selectBetweenPaymentDate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentEndDate", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.canAccess('member-loan-plan-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Member Collection")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('staff-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/membercollection/export/excel")
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\n          ")]) : _vm._e(), _vm._v(" "), _c('strong', [_c('big', [_vm._v("Total Amount: " + _vm._s(this.totalAmount) + " ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsMemberCollections), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [(row.member_loan_plan) ? _c('span', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.type))]), _vm._v(" "), _c('td', [(row.collection_center_id) ? _c('span', [_vm._v(_vm._s(row.collection_center.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.paymentDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.amt))]), _vm._v(" "), _c('td', [(row.received_by) ? _c('span', [_vm._v(_vm._s(row.received_by.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(row.branch_ledger) ? _c('span', [_vm._v(_vm._s(row.branch_ledger.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(row.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (row.status == 'paid') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (row.status == 'approved') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Approved")]) : _vm._e(), _vm._v(" "), (row.status == 'partial') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Partial")]) : _vm._e()])])
  }), 0)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Recovery type\n                    "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Plan Type\n                    "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Payment Type "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Payment Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("LoanID ")]), _vm._v(" "), _c('th', [_vm._v("Mem Name ")]), _vm._v(" "), _c('th', [_vm._v("Mem Code ")]), _vm._v(" "), _c('th', [_vm._v("Mobile")]), _vm._v(" "), _c('th', [_vm._v("Payment Type")]), _vm._v(" "), _c('th', [_vm._v("CenterName")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Received By")]), _vm._v(" "), _c('th', [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43be319e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Reports/CollectionReport.vue
// module id = 752
// module chunks = 0